import { createAction } from "redux-actions";

export const setStatusType = createAction("SET_STATUS_TYPE");